
import {useMemo} from 'react';
import HtmlParser, { innerBold, innerWidth } from '../HtmlParser';
import style from './index.module.less';

export default function SubTitle(props: {desc: string; keyIndex: number; staticWidth?: boolean;}) {
  const {desc, keyIndex, staticWidth = false} = props;
  const arr = useMemo(() => desc.split('\n'), [desc]);
  return (
    <div className={style.subTitleBox} data-key={`question.question.${keyIndex}.desc`}>
      <div className={style.subTitle}>
        <HtmlParser htmlString={arr[0]}></HtmlParser>
      </div>
      <div className={style.instructions}>
        {
          arr.slice(1).map((item, index) => {
            return <p className={style.instructions_line} key={index}>
              {
                item ? 
                  <HtmlParser htmlString={innerBold(staticWidth ? innerWidth(item) : item)}></HtmlParser>
                  : index !== 0 && index !== (arr.length - 2) ? <br /> : null
              }</p>;
          })
        }
      </div>
    </div>
    
  );
}